// https://tympanus.net/codrops/2019/01/31/custom-cursor-effects/

// Cursor canvas packages
let SimplexNoise = require('simplex-noise');
let paper = require('paper/dist/paper-core');

const cursorJs = function () {

  // set the starting position of the cursor outside of the screen
  let clientX = -100;
  let clientY = -100;
  let rotate = 45;

  let lastX = 0;
  let lastY = 0;
  let isStuck = false;
  let isLarge = false;
  let showCursor = false;
  let group, stuckX, stuckY, fillOuterCursor;

  if (screen.width <= 768) {
    return;
  }

  const initCanvas = () => {

    // add listener to track the current mouse position
    document.addEventListener("mousemove", e => {
      clientX = e.clientX;
      clientY = e.clientY;
    });

    // const innerCursor = document.querySelector(".cursor__small");
    const canvas = document.querySelector(".cursor__canvas");
    const shapeBounds = {
      width: 50,
      height: 50
    };
    paper.setup(canvas);
    const strokeColor = "#B4B89100"; //"rgba(255, 0, 0, 0.5)";
    const strokeColorAlfa = "#B4B89150"; //"rgba(255, 0, 0, 0.5)";
    const strokeColorTrans = "#B4B89120"; //"rgba(255, 0, 0, 0)";
    const strokeWidth = 1;
    const segments = 8;
    const radius = 30;

    // we'll need these later for the noisy circle
    const noiseScale = 150; // speed
    const noiseRange = 4; // range of distortion
    let isNoisy = false; // state

    let sizeFactor = 0.3;

    let logo1x1 = 26.7 * sizeFactor;
    let logo1y1 = 50 * sizeFactor;
    let logo1x2 = 48.8 * sizeFactor;
    let logo1y2 = 27.9 * sizeFactor;
    let logo1x3 = 48.8 * sizeFactor;
    let logo1y3 = 1.2 * sizeFactor;
    let logo1x4 = 0;
    let logo1y4 = 50 * sizeFactor;
    let logo1x5 = 48.8 * sizeFactor;
    let logo1y5 = 98.8 * sizeFactor;
    let logo1x6 = 48.8 * sizeFactor;
    let logo1y6 = 72.1 * sizeFactor;

    let logo2x1 = 78.7 * sizeFactor;
    let logo2y1 = 26.4 * sizeFactor;
    let logo2x2 = 57.5 * sizeFactor;
    let logo2y2 = 47.6 * sizeFactor;
    let logo2x3 = 100 * sizeFactor;
    let logo2y3 = 47.6 * sizeFactor;

    let logo3x1 = 78.7 * sizeFactor;
    let logo3y1 = 73.6 * sizeFactor;
    let logo3x2 = 100 * sizeFactor;
    let logo3y2 = 52.4 * sizeFactor;
    let logo3x3 = 57.5 * sizeFactor;
    let logo3y3 = 52.4 * sizeFactor;

    let logo4x1 = 75.4 * sizeFactor;
    let logo4y1 = 76.9 * sizeFactor;
    let logo4x2 = 53.5 * sizeFactor;
    let logo4y2 = 55.1 * sizeFactor;
    let logo4x3 = 53.5 * sizeFactor;
    let logo4y3 = 98.8 * sizeFactor;

    let logo5x1 = 75.4 * sizeFactor;
    let logo5y1 = 23 * sizeFactor;
    let logo5x2 = 53.5 * sizeFactor;
    let logo5y2 = 1.2 * sizeFactor;
    let logo5x3 = 53.5 * sizeFactor;
    let logo5y3 = 44.9 * sizeFactor;

    let logo1 = new paper.Path();
    logo1.add(new paper.Point(logo1x1, logo1y1));
    logo1.add(new paper.Point(logo1x2, logo1y2));
    logo1.add(new paper.Point(logo1x3, logo1y3));
    logo1.add(new paper.Point(logo1x4, logo1y4));
    logo1.add(new paper.Point(logo1x5, logo1y5));
    logo1.add(new paper.Point(logo1x6, logo1y6));
    logo1.fillColor = strokeColor;

    let logo2 = new paper.Path();
    logo2.add(new paper.Point(logo2x1, logo2y1));
    logo2.add(new paper.Point(logo2x2, logo2y2));
    logo2.add(new paper.Point(logo2x3, logo2y3));
    logo2.fillColor = strokeColor;

    let logo3 = new paper.Path();
    logo3.add(new paper.Point(logo3x1, logo3y1));
    logo3.add(new paper.Point(logo3x2, logo3y2));
    logo3.add(new paper.Point(logo3x3, logo3y3));
    logo3.fillColor = strokeColor;

    let logo4 = new paper.Path();
    logo4.add(new paper.Point(logo4x1, logo4y1));
    logo4.add(new paper.Point(logo4x2, logo4y2));
    logo4.add(new paper.Point(logo4x3, logo4y3));
    logo4.fillColor = strokeColor;

    let logo5 = new paper.Path();
    logo5.add(new paper.Point(logo5x1, logo5y1));
    logo5.add(new paper.Point(logo5x2, logo5y2));
    logo5.add(new paper.Point(logo5x3, logo5y3));
    logo5.fillColor = strokeColor;

    let logoGroup = new paper.Group();
    logoGroup.addChild(logo1);
    logoGroup.addChild(logo2);
    logoGroup.addChild(logo3);
    logoGroup.addChild(logo4);
    logoGroup.addChild(logo5);
    logoGroup.applyMatrix = false;

    logoGroup.style.animation = `scale 3s`;

    group = logoGroup;

    //const noiseObjects = polygon.segments.map(() => new SimplexNoise());
    let bigCoordinates = [];

    // function for linear interpolation of values
    const lerp = (a, b, n) => {
      return (1 - n) * a + n * b;
    };

    // function to map a value from one range to another range
    const map = (value, in_min, in_max, out_min, out_max) => {
      return (
        ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
      );
    };

    // the draw loop of Paper.js
    // (60fps with requestAnimationFrame under the hood)
    // paper.view.onFrame = event => {
    //     // using linear interpolation, the circle will move 0.2 (20%)
    //     // of the distance between its current position and the mouse
    //     // coordinates per Frame
    //     lastX = lerp(lastX, clientX, 0.2);
    //     lastY = lerp(lastY, clientY, 0.2);
    //     group.position = new paper.Point(lastX, lastY);
    // }


    // the draw loop of Paper.js
    // (60fps with requestAnimationFrame under the hood)
    paper.view.onFrame = event => {
      // using linear interpolation, the circle will move 0.2 (20%)
      // of the distance between its current position and the mouse
      // coordinates per Frame

      if (!isStuck) {
        // move circle around normally
        lastX = lerp(lastX, clientX, 0.2);
        lastY = lerp(lastY, clientY, 0.2);
        logoGroup.position = new paper.Point(lastX, lastY);
        logoGroup.fillColor = strokeColorAlfa;
      } else if (isStuck) {
        // fixed position on a nav item
        lastX = lerp(lastX, clientX, 0.2);
        lastY = lerp(lastY, clientY, 0.2);
        // lastX = lerp(lastX, stuckX, 0.2);
        // lastY = lerp(lastY, stuckY, 0.2);
        logoGroup.position = new paper.Point(lastX, lastY);
        logoGroup.fillColor = strokeColorAlfa;
      }

    };
  }


  initCanvas();


  const initHovers = () => {

    // find the center of the link element and set stuckX and stuckY
    // these are needed to set the position of the noisy circle
    const handleMouseEnter = e => {
      const navItem = e.currentTarget;
      const navItemBox = navItem.getBoundingClientRect();
      // stuckX = Math.round(navItemBox.left + navItemBox.width / 2);
      // stuckY = Math.round(navItemBox.top + navItemBox.height / 2);
      isStuck = true;
      group.visible = true;
    };

    // reset isStuck on mouseLeave
    const handleMouseLeave = () => {
      isStuck = false;
      group.visible = false;
    };

    // find the center of the link element and set stuckX and stuckY
    // these are needed to set the position of the noisy circle
    const handleMouseEnterButton = e => {
      const navItem = e.currentTarget;
      const navItemBox = navItem.getBoundingClientRect();
      // stuckX = Math.round(navItemBox.left + navItemBox.width / 2);
      // stuckY = Math.round(navItemBox.top + navItemBox.height / 2);
      isStuck = true;
      group.visible = true;
    };

    // add event listeners to all items
    const linkItems = document.querySelectorAll(".link");
    linkItems.forEach(item => {
      item.addEventListener("mouseenter", handleMouseEnter);
      item.addEventListener("mouseleave", handleMouseLeave);
    });

    // add event listeners to all items
    const buttonItems = document.querySelectorAll(".button, .menu-icon, .js--cursor-link");
    buttonItems.forEach(item => {
      item.addEventListener("mouseenter", handleMouseEnterButton);
      item.addEventListener("mouseleave", handleMouseLeave);
    });


    // reset isStuck on mouseLeave
    const handleMouseLeaveHide = () => {
      isLarge = false;
      isStuck = false;
      group.visible = false;
    };

    // find the center of the link element and set stuckX and stuckY
    // these are needed to set the position of the noisy circle
    const handleMouseEnterButtonHide = e => {
      const navItem = e.currentTarget;
      const navItemBox = navItem.getBoundingClientRect();
      // stuckX = Math.round(navItemBox.left + navItemBox.width / 2);
      // stuckY = Math.round(navItemBox.top + navItemBox.height / 2);
      isLarge = true;
      isStuck = true;
      group.visible = true;
    };

    // add event listeners to all items
    const buttonItemsHide = document.querySelectorAll(".js--cursor-link-large");
    buttonItemsHide.forEach(item => {
      item.addEventListener("mouseenter", handleMouseEnterButtonHide);
      item.addEventListener("mouseleave", handleMouseLeaveHide);
    });

  };

  initHovers();

}

export default cursorJs;
